import { constants } from "redux/constants/redux-constants";

export const encounterObject = (task) => ({
  type: constants.ENCOUNTER?.ENCOUNTER_OBJECT,
  payload: task,
});

export const setVisitObject = (task) => ({
  type: constants.ENCOUNTER?.VISIT_OBJECT,
  payload: task,
});

export const addVisitObject = (task) => ({
  type: constants?.ENCOUNTER?.ADD_VISIT,
  payload: task,
});

export const toggleSelect = (task) => ({
  type: constants?.ENCOUNTER?.TOGGLE_SELECT,
  payload: task,
});
export const quickActionToggle = (task) => ({
  type: constants?.ENCOUNTER?.QUICK_ACTION_TOGGLE,
  payload: task,
});

export const setEncounterResource = (task) => ({
  type: constants.ENCOUNTER?.ENCOUNTER_RESOURCE,
  payload: task,
});
export const setArchivedEncounterResource = (task) => ({
  type: constants.ENCOUNTER?.ARCHIVED_ENCOUNTER_RESOURCE,
  payload: task,
});
export const setObservations = (payload) => ({
  type: constants.ENCOUNTER?.SET_OBSERVATIONS,
  payload,
});

export const setEncounterNote = (task) => ({
  type: constants.ENCOUNTER?.ENCOUNTER_NOTE,
  payload: task,
});

export const setConsolidatedNote = (payload) => ({
  type: constants.ENCOUNTER.CONSOLIDATED_NOTE,
  payload,
});

export const setFirstVisitSelected = (payload) => ({
  type: constants.ENCOUNTER?.FIRST_VISIT_SELECTED,
  payload: payload
})

export const setPreviousEncounterObservations = (payload) => ({
  type: constants.ENCOUNTER?.PREVIOUS_ENCOUNTER_OBSERVATIONS,
  payload: payload
})
